import React from 'react';
import "../css/MonitoreodeEntrenamiento.css";

const MonitoreodeEntrenamiento = () => {
    return (
        <div>
            <div className="container-mon">
                <div className="fila">
                    <div className="sub-fila">
                        <div className="caja">
                            <h5>Error absoluto medio</h5>
                            <div className="iframe-container">
                            <iframe 
                                src="https://snapshots.raintank.io/dashboard-solo/snapshot/fBSB3t7lJlUCTh4ujcP7uflaFfb73n2B?orgId=0&from=1733821196751&to=1733821292559&panelId=23" 
                                width="450" 
                                height="200" 
                                frameborder="0"
                                title='Error absoluto medio'
                                ></iframe>
                            </div>
                        </div>
                        <div className="caja">
                            <h5>Pérdida de modelo (RMSE)</h5>
                            <div className="iframe-container">
                            <iframe 
                            src="https://snapshots.raintank.io/dashboard-solo/snapshot/EKlD5PW9y6IhqTwjgprZuHV8WZTI2APC?orgId=0&from=1733821196751&to=1733821292559&panelId=21" 
                            width="450" 
                            height="200" 
                            frameborder="0"
                            title='Pérdida de modelo (RMSE)'
                            ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fila">
                    <div className="sub-fila">
                        <div className="caja">
                            <h5>Uso de la memoria</h5>
                            <div className="iframe-container">
                            <iframe 
                                src="https://snapshots.raintank.io/dashboard-solo/snapshot/eRxrS1iy73kHAl3YBg1aoIjbY8vUdYH4?orgId=0&from=1733821196751&to=1733821292559&panelId=9" 
                                width="450" 
                                height="200" 
                                frameborder="0"  
                                title='Uso de la memoria'
                            ></iframe>
                            </div>
                        </div>
                        <div className="caja">
                            <h5>Memoria en caché</h5>
                            <div className="iframe-container">
                            <iframe 
                                src="https://snapshots.raintank.io/dashboard-solo/snapshot/n4ElBV7D8S8zCMJcAuLggw9TTtokIsjt?orgId=0&from=1733821196751&to=1733821292559&panelId=14" 
                                width="450" 
                                height="200" 
                                frameborder="0"
                                title='Memoria en caché'
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>     
                <div className="fila">
                    <div className="caja full-width">
                        <h5>Información de los contenedores</h5>
                        <div className="iframe-container">
                        <iframe 
                            src="https://snapshots.raintank.io/dashboard-solo/snapshot/vtWKqSGkeMWzGtk79MH68YftD19tKoTL?orgId=0&from=1733821196883&to=1733821308350&panelId=17" 
                            width="450" 
                            height="200" 
                            frameborder="0"
                            title='Información de los contenedores'
                        ></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <div className="logos-container-monitoreo">
                <img src="app/ue-color.png" alt="Union" className="logo-monitoreo" />
                <img src="app/ministerio-color.png" alt="Ministerio" className="logo-monitoreo" /> 
                <img src="app/plan_recuperacion_color.png" alt="Recuperacion" className="logo-monitoreo" /> 
            </div>
        </div>
    );
};

export default MonitoreodeEntrenamiento;
